module.exports = __webpack_public_path__ + "static/media/sl.f5cb409d.svg";